import React from "react";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";
import {useTranslation} from "react-i18next";
import {QuantityOptionDTO} from "@/api/data-contracts";
import {RequestI18N} from "@/translations";
import {formatCurrency, formatInteger} from "@/lib/utils";

export interface RequestQuantityCellProps {
    quantityOptions: QuantityOptionDTO[] | undefined;
    locale: string;
}

/**
 * Renders the quantity column cell showing each quantity option.
 */
export const RequestQuantityCell: React.FC<RequestQuantityCellProps> = ({quantityOptions, locale}) => {
    const {t} = useTranslation();
    return (
        <Table border={0}>
            <TableBody>
                {quantityOptions?.map((qo) => (
                    <TableRow key={qo.quantity}>
                        <TableCell>
                            {formatInteger(qo.quantity, locale)} {t(RequestI18N.details.field.pcsShort)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export interface RequestPriceCellProps {
    quantityOptions: QuantityOptionDTO[] | undefined;
    locale: string;
}

/**
 * Renders the net price per 1000 column cell for each quantity option.
 */
export const RequestPriceCell: React.FC<RequestPriceCellProps> = ({quantityOptions, locale}) => (
    <Table border={0}>
        <TableBody>
            {quantityOptions?.map((qo) => (
                <TableRow key={qo.quantity}>
                    <TableCell>{formatCurrency(qo.netPricePer1000, locale) ?? <>&nbsp;</>}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    </Table>
);

export interface RequestTotalPriceCellProps {
    quantityOptions: QuantityOptionDTO[] | undefined;
    locale: string;
}

/**
 * Renders the net total price column cell for each quantity option.
 */
export const RequestTotalPriceCell: React.FC<RequestTotalPriceCellProps> = ({quantityOptions, locale}) => (
    <Table border={0}>
        <TableBody>
            {quantityOptions?.map((qo) => (
                <TableRow key={qo.quantity}>
                    <TableCell>{formatCurrency(qo.netPriceTotal, locale) ?? <>&nbsp;</>}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    </Table>
);
